var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasCheckedAccess)?_c('geko-base-crud',{attrs:{"config":_vm.config,"refreshKey":_vm.refreshKey,"hideUpdate":true,"hideDelete":!_vm.isAssignedAsFC,"hideCreate":!_vm.isAssignedAsFC},scopedSlots:_vm._u([{key:"create-city",fn:function({ formData }){return [_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                type: 'select',
                label: 'Kota / Kabupaten',
                api: 'GetKabupaten',
                validation: ['required'],
                param: { province_code: formData.province },
                option: {
                    getterKey: 'data.result',
                    list_pointer: { label: 'name', code: 'kabupaten_no', display: ['name'] },
                },
            },"disabled":!formData.province},model:{value:(formData.city),callback:function ($$v) {_vm.$set(formData, "city", $$v)},expression:"formData.city"}})],1)]}},{key:"create-kecamatan",fn:function({ formData }){return [_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                type: 'select',
                label: 'Kecamatan',
                api: 'GetKecamatan',
                validation: ['required'],
                param: { kabupaten_no: formData.city },
                option: {
                    getterKey: 'data.result',
                    list_pointer: { label: 'name', code: 'kode_kecamatan', display: ['name'] },
                },
            },"disabled":!formData.city},model:{value:(formData.kecamatan),callback:function ($$v) {_vm.$set(formData, "kecamatan", $$v)},expression:"formData.kecamatan"}})],1)]}},{key:"create-village",fn:function({ formData }){return [_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                type: 'select',
                label: 'Desa',
                api: 'GetDesa',
                validation: ['required'],
                param: { kode_kecamatan: formData.kecamatan },
                option: {
                    getterKey: 'data.result',
                    list_pointer: { label: 'name', code: 'kode_desa', display: ['name'] },
                },
            },"disabled":!formData.kecamatan},model:{value:(formData.village),callback:function ($$v) {_vm.$set(formData, "village", $$v)},expression:"formData.village"}})],1)]}},{key:"create-mu_no",fn:function({ formData }){return [_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("AREA KERJA")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                type: 'select',
                label: 'Management Unit',
                api: 'GetManagementUnit',
                validation: ['required'],
                param: {
                    program_year: formData.program_year,
                },
                option: {
                    getterKey: 'data.result',
                    list_pointer: {
                        label: 'name',
                        code: 'mu_no',
                        display: ['name'],
                    },
                },
            }},model:{value:(formData.mu_no),callback:function ($$v) {_vm.$set(formData, "mu_no", $$v)},expression:"formData.mu_no"}})],1)]}},{key:"create-target_area",fn:function({ formData }){return [_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                type: 'select',
                label: 'Target Area',
                api: 'new-utilities/target-areas',
                validation: ['required'],
                param: {
                    program_year: formData.program_year,
                    mu_no: formData.mu_no,
                },
                option: {
                    getterKey: 'data',
                    list_pointer: {
                        label: 'name',
                        code: 'area_code',
                        display: ['name'],
                    },
                },
            }},model:{value:(formData.target_area),callback:function ($$v) {_vm.$set(formData, "target_area", $$v)},expression:"formData.target_area"}})],1)]}},{key:"create-working_area",fn:function({ formData }){return [_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                type: 'select',
                label: 'Working Area / Desa',
                api: 'GetDesa',
                validation: ['required'],
                param: {
                    program_year: formData.program_year,
                    kode_ta: formData.target_area,
                },
                option: {
                    getterKey: 'data.result',
                    list_pointer: {
                        label: 'name',
                        code: 'kode_desa',
                        display: ['name'],
                    },
                },
            }},model:{value:(formData.working_area),callback:function ($$v) {_vm.$set(formData, "working_area", $$v)},expression:"formData.working_area"}})],1)]}},{key:"list-indicator",fn:function({ item }){return [_c('div',{staticClass:"indicator-wrapper pt-1"},[_c('div',{staticClass:"indicator",class:{
                danger: item.active == 0,
                success: item.active == 1,
            }})])]}},{key:"list-after-filter",fn:function(){return [_c('div',{staticClass:"d-flex flex-row justify-content-between"},[_c('div',[_c('v-btn-toggle',{attrs:{"mandatory":"","color":"primary"},on:{"change":function($event){_vm.refreshKey += 1}},model:{value:(_vm.config.dataSource),callback:function ($$v) {_vm.$set(_vm.config, "dataSource", $$v)},expression:"config.dataSource"}},[_c('v-btn',{attrs:{"value":"external","small":""}},[_vm._v("Data External (V3)")]),_c('v-btn',{attrs:{"value":"internal","small":""}},[_vm._v("Data Internal (Employee)")])],1)],1),(_vm.isAssignedAsFC)?_c('div',[_c('v-btn',{staticClass:"mr-2",attrs:{"color":"success"},on:{"click":function($event){_vm.isAssignModalOpen = true}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-account-arrow-right")]),_c('span',{staticClass:"ms-2"},[_vm._v("Assign Karyawan")])],1)],1):_vm._e()]),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.isAssignModalOpen),callback:function ($$v) {_vm.isAssignModalOpen=$$v},expression:"isAssignModalOpen"}},[_c('v-card',[_c('v-card-title',[_vm._v("Assign Karyawan FF")]),_c('v-card-text',{staticClass:"pt-4"},[_c('geko-input',{attrs:{"item":{
                        type: 'select',
                        label: 'Pilih Karyawan',
                        api: 'monitoring-officer-v3/ff/options/public',
                        param: {
                            program_year: _vm.$store.state.tmpProgramYear,
                            is_monitoring: null // => jika is_monitoring = 1 maka datanya tidak akan muncul alias dikecualikan
                        },
                        option: {
                            getterKey: 'data',
                            list_pointer: { label: 'name', code: 'ff_no', display: ['name', 'ff_no', 'users_email'] }
                        },
                    }},model:{value:(_vm.assignPayload.ff_no),callback:function ($$v) {_vm.$set(_vm.assignPayload, "ff_no", $$v)},expression:"assignPayload.ff_no"}})],1),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.isAssignModalOpen = false}}},[_vm._v("Batal")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.submitAssignExisting}},[_vm._v("Assign Karyawan")])],1)],1)],1)]},proxy:true}],null,false,3230683956)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }